import React from 'react';
import MetaLocation from '../../components/metaai/MetaLocation';

const MetaAILocation = () => {
  return (
    <div>
      <MetaLocation 
        address="서울 강서구 공항대로 237, 1207호(마곡동, 에이스타워마곡)"
      />
    </div>
  )
}

export default MetaAILocation